import { render, staticRenderFns } from "./CheckSettingsPage.vue?vue&type=template&id=cb5b8c04&scoped=true"
import script from "./CheckSettingsPage.vue?vue&type=script&lang=js"
export * from "./CheckSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./CheckSettingsPage.vue?vue&type=style&index=0&id=cb5b8c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5b8c04",
  null
  
)

export default component.exports